(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const inputs = document.querySelectorAll('.PP-TextField__Input');
    const buttonTrack = document.querySelector('.pp_tracking_button');
    const buttonBack = document.querySelector('.pp_back_butoon');
    const formWrapper = document.querySelector('.pp_tracking_form_in');
    const form = document.querySelector('.pp_tracking_form');
    const logo = document.querySelector('.pp_logo_wrapper img');

    if (!buttonTrack || !buttonBack || !inputs.length || !form || !formWrapper || !logo) return;

    const header = document.createElement('div');
    const headerContent = document.createElement('div');
    const headerContentInner = document.createElement('div');
    header.className = 'header header--default header--alignment-left header--position-inline header--content-normal header--style-is-icon header--has-transparent-logo animation animation--header header--has-logo header--transparent';
    headerContent.className = 'header__content';
    headerContentInner.className = 'header__content-inner flex justify-between w-100';

    const buttonBackClonned = buttonBack.cloneNode(true);
    buttonBackClonned.style.visibility = 'hidden';

    document.querySelector('body').prepend(header);
    header.append(headerContent);
    headerContent.append(headerContentInner);
    headerContentInner.append(buttonBack);
    headerContentInner.append(logo);
    headerContentInner.append(buttonBackClonned);

    formWrapper.style.paddingBottom = '1rem';

    const undertext = document.createElement('div');
    undertext.style.fontSize = '13px';
    undertext.style.marginTop = '15px';
    undertext.style.textAlign = 'center';
    undertext.innerHTML = 'Questions? Contact <a class="pp_email-link" href="mailto:info@spktrl-paris.com">info@spktrl-paris.com</a>';

    form.append(undertext);

    form.addEventListener('submit', e => {
      e.preventDefault();
    });

    [...buttonBack.children][0].href = '/';

    const checkFields = () => {
      const allFilled = Array.from(inputs).every((input) => input.value.trim() !== '');
      buttonTrack.classList.toggle('btn-disabled', !allFilled);
    };

    buttonTrack.disabled = true;
    buttonTrack.innerHTML = 'Tracking will be activate after the Pre-Orders campaign.';
    buttonTrack.style = 'font-size: 14px;';

    const hasOrderParam = window.location.search.includes('order=');

    inputs.forEach((input) => {
      if (input.name === "email") {
        input.type = 'email';
      }

      const span = input.closest('.pp_tracking_parent').querySelector('.pp_tracking_span');
      const spanContent = span.firstElementChild;

      if (spanContent.innerHTML === "Email or Phone Number") {
        spanContent.innerHTML = "Email";
      }

      if (hasOrderParam) {
        span.classList.add('PP-TextField__Container--hasValue');
      }

      input.addEventListener('input', () => {
        span.classList.toggle('PP-TextField__Container--hasValue', input.value.trim() !== '');
        checkFields();
      });

      input.disabled = true;
    });

    checkFields();
  });
})();
